import { register } from "@rill/loader";

register(
  {
    name: "clientConfigurationTemplates",
    meta: ["no-bust", "client-configuration-templates"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete } = {}) => {
    const query = proxyAthlete ? { clientId: proxyAthlete } : undefined;
    const res = await api("client-configuration-templates", { query });
    const data = await res.json();
    if (Array.isArray(data)) return data;
    return data.templates ?? [];
  }
);
